import { render } from "./TheProfessionalHome.vue?vue&type=template&id=2e3e69aa&ts=true"
import script from "./TheProfessionalHome.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalHome.vue?vue&type=script&lang=ts"

import "./TheProfessionalHome.vue?vue&type=style&index=0&id=2e3e69aa&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__